/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { FC } from 'react';
import { translate } from '../utils/utils';
import Labels from 'enums/Labels';
import AppStorage from '../Storage/Storage';

interface ReadSpeakerReaderProps {
  id?: string;
  labelsIgnoreSelector?: string;
}

const ReadSpeakerReader: FC<ReadSpeakerReaderProps> = ({
  id = 'main-content',
  labelsIgnoreSelector,
}) => {
  const storage = AppStorage.getInstance();

  const listenLable = translate(Labels.LISTEN, storage.getLocale);

  const serverURL = `https://app-eu.readspeaker.com/cgi-bin/rsent?customerid=15092&lang=en_uk&readid=${id}&url=${encodeURIComponent(window.location.href)}`;

  const handleBeforeOpen = (): void => {
    try {
      const selector = labelsIgnoreSelector ?? '';
      (window as any).rspkr?.conf?.('general.labels.ignoreSelector', selector);
    } catch (_e) {}
  };

  return (
    <React.Fragment>
      <section className="readspeaker-button-section mt-3 mb-2">
        <div className="rs_skip rsbtn">
          <a
            rel="nofollow"
            className="rsbtn_play"
            href={serverURL}
            id="rsbtn_play"
            onClick={handleBeforeOpen}
          >
            <span className="rsbtn_left rsimg rspart">
              <span className="rsbtn_text">
                <span>{listenLable}</span>
              </span>
            </span>
            <span className="rsbtn_right rsimg rsplay rspart"></span>
          </a>
        </div>
      </section>
    </React.Fragment>
  );
};

export default ReadSpeakerReader;
